import { useAuth } from './useAuth'
import { useStores } from './useStores'
import { Modal } from 'antd'
import { useRouter } from 'next/router'

const { confirm } = Modal

export const useValidateAuth = () => {
  const { store } = useStores()
  const {
    isLogin,
    isRealName,
    isBindBankCard,
    isTradePwd,
    isCreator,
    isAiCreator,
    isOrganization,
  } = useAuth()
  const router = useRouter()

  const validateIsLogin = () => {
    if (!isLogin) {
      store.modal?.setLoginVisible(true)
      return false
    }

    return true
  }

  const validateIsRealName = () => {
    if (!isRealName) {
      confirm({
        title: '提示',
        content: '为保证账户安全，请先进行实名认证',
        icon: '',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 300,
        onOk: () => {
          if (isOrganization) {
            router.push('/settings/safety')
          } else {
            store.modal?.setRealNameAuthVisible(true)
          }
        },
        okText: '前往认证',
      })

      return false
    }

    return true
  }

  const validateBindBankCard = () => {
    if (!isBindBankCard) {
      confirm({
        title: '提示',
        content: '为保证账户安全，请先绑定银行卡',
        icon: '',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 300,
        onOk: () => {
          router.push('/settings/bank-card')
        },
        okText: '前往绑定',
      })

      return false
    }

    return true
  }

  const validateTradePwd = () => {
    if (!isTradePwd) {
      confirm({
        title: '提示',
        content: '为保证账户安全，请先设置交易密码',
        icon: '',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 300,
        onOk: () => {
          store.modal?.setTradePwdVisible(true)
        },
        okText: '前往设置',
      })

      return false
    }

    return true
  }

  const validateCreatorOrAiCreator = () => {
    if (!(isCreator || isAiCreator)) {
      confirm({
        title: '提示',
        content: '你当前不是创作者，请前往申请成为创作者',
        icon: '',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 300,
        onOk: () => {
          router.push('/to-be-creator')
        },
        okText: '前往申请',
      })

      return false
    }

    return true
  }

  return {
    validateIsLogin,
    validateIsRealName,
    validateBindBankCard,
    validateTradePwd,
    /** 校验是否是普通创作者或者ai创作者 */
    validateCreatorOrAiCreator,
  }
}
